import { Injectable } from '@angular/core';
import { HttpClient,  } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
@Injectable({ providedIn: 'root'})

export class GetHTTPService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public outputValues(state): void {
    this.getCareList(state).subscribe(x => super.next(x));
  }
  getCareList(state): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Employee/Getpendingumpifilter1", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['employeelst'],
            count: response['employeeTotal']
          }
      ))
  }  
}


